import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';

const SocialGoogle = ({ testId, className })=>{
    return /*#__PURE__*/ jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: [
            /*#__PURE__*/ jsxs("g", {
                clipPath: "url(#clip0_2735_3764)",
                children: [
                    /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M16 8.18185C16 7.61474 15.9483 7.06897 15.8513 6.54541H8.16327V9.63963H12.5569C12.3674 10.6396 11.7923 11.4876 10.9279 12.0547V14.0619H13.5656C15.1093 12.669 16 10.6183 16 8.18185Z",
                        fill: "#3E82F1"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M8.1632 16C10.3673 16 12.2149 15.2836 13.5655 14.0622L10.9278 12.0542C10.1968 12.5342 9.26162 12.8178 8.1632 12.8178C6.03711 12.8178 4.23755 11.4107 3.59537 9.52002H0.86792V11.5929C2.21124 14.2071 4.97225 16 8.1632 16Z",
                        fill: "#32A753"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M3.59548 9.51999C3.43222 9.03999 3.3397 8.5271 3.3397 7.99999C3.3397 7.47288 3.43222 6.95999 3.59548 6.47999V4.4071H0.868032C0.315648 5.4871 0 6.70933 0 7.99999C0 9.29066 0.315648 10.5129 0.868032 11.5929L3.59548 9.51999Z",
                        fill: "#F9BB00"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M8.1632 3.18186C9.36139 3.18186 10.438 3.58541 11.2834 4.3783L13.6254 2.08408C12.2113 0.792523 10.3637 -0.000366211 8.1632 -0.000366211C4.97225 -0.000366211 2.21124 1.79252 0.86792 4.40763L3.59537 6.47963C4.23755 4.58897 6.03711 3.18186 8.1632 3.18186Z",
                        fill: "#E74235"
                    })
                ]
            }),
            /*#__PURE__*/ jsx("defs", {
                children: /*#__PURE__*/ jsx("clipPath", {
                    id: "clip0_2735_3764",
                    children: /*#__PURE__*/ jsx("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

export { SocialGoogle as default };
